// @ts-strict-ignore
import { Editor } from 'slate';
import { MyEditor } from 'src/components/textEditor/customHelpers';
import { MAX_CHARS_REPLY_BODY, MIN_CHARS_REPLY } from 'src/constants/write';
import { stripBBTags } from 'src/utils/string';
import i18n from 'src/utils/translate';

type ValidateProps = {
  editor?: Editor,
  mentionCount?: number, // only used with android editors!
  text?: string, // only used with android editors!
  setIsDirty: (isDirty: boolean) => void,
  setIsSubmitDisabled: (isSubmitDisabled: boolean) => void,
}

export const validateReply = ({ editor, setIsDirty, setIsSubmitDisabled, mentionCount, text }: ValidateProps): string[] => {
  // emojis count as 2 char.
  const messages = []; // currently, we don't display errors, but Manar wanted to add some errors and max/mins, like in Write a post. Needs product.

  // single mention is enough to pass validation, disregarding min-length
  const mentionsCount = editor ? MyEditor.countElementOccurrence(editor, 'mention') : mentionCount;

  const post = editor ? MyEditor.getString(editor, []) : text;

  const cleanText = !!post.length && stripBBTags(post) || '';
  const trimmedText = cleanText.trim();

  if (cleanText.length > 0 || mentionsCount > 0) {
    setIsDirty(true);
  }

  if (trimmedText.length >= MIN_CHARS_REPLY || mentionsCount > 0) {
    setIsSubmitDisabled(false);
  } else {
    setIsSubmitDisabled(true);
  }

  switch (true) {
    case ((cleanText?.length === 0 || trimmedText.length === 0) && mentionsCount === 0):
      setIsDirty(false);
      messages.push(i18n.t('You forgot to write a comment'));
      return messages;
    case ((cleanText?.length < MIN_CHARS_REPLY || trimmedText.length < MIN_CHARS_REPLY) && mentionsCount === 0):
      messages.push(i18n.t(`Replies must have at least ${MIN_CHARS_REPLY} characters`));
      return messages;
    case cleanText?.length === MAX_CHARS_REPLY_BODY:
      return messages;
    case cleanText?.length > MAX_CHARS_REPLY_BODY:
      messages.push(i18n.t(`Comments can have maximum ${MAX_CHARS_REPLY_BODY} characters`));
      return messages;
    default:
      return messages;
  }
};
